import React, { useRef } from 'react'
import { SkillBiteEditSlice } from '../../../../../reducers'
import { useSelector } from 'react-redux'
import { IconButton, Tooltip } from '@mui/material'
import SessionFormDialog from '../session-form-dialog'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { BannerStatic } from '../../../../../components'
import { EditRounded } from '@mui/icons-material'

const EditSessionDialog = ({ session, className }) => {
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)
  const modalRef = useRef()

  const [updateSession] = useEvent([
    SkillBiteEditSlice.eventBus.updateSession({
      onSuccess: () => {
        BannerStatic.show({
          label: 'Session updated successfully'
        })
        modalRef.current.close()
      },
      onError: (error) => {
        console.log(error)
        BannerStatic.show({
          label: 'Error trying to update session',
          isError: true
        })
        modalRef.current.close()
      }
    })
  ])

  const handleClickOpen = (evt) => {
    evt.preventDefault()
    evt.stopPropagation()
    modalRef.current.open({
      name: session.name,
      description: session.description
    })
  }

  const handleOnSubmit = (data) => {
    updateSession.trigger({
      skillBiteId: skillBite.id,
      sessionId: session.id,
      name: data.name,
      description: data.description
    })
  }

  return (
    <>
      <Tooltip placement='top' title='Edit Session'>
        <IconButton
          data-test='edit-session-btn'
          onClick={handleClickOpen}
          aria-label='Update session'
          size='small'
          className={className}
        >
          <EditRounded
            fontSize='small'
          />
        </IconButton>
      </Tooltip>

      <SessionFormDialog
        title='Edit Session'
        submitText='Save'
        isLoading={updateSession.isWorking}
        ref={modalRef}
        onSubmit={handleOnSubmit}
        session={session}
      />
    </>
  )
}

export default EditSessionDialog
